export default __webpack_public_path__ + "static/media/PictureH.b1d53c6f.jpg";